import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import EditRakePointForm from './EditRakePointForm';

const EditRakePointDialog = ({ open, onOpenChange, rakePoint, onUpdateRakePoint }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (payload) => {
    setSubmitting(true);
    try {
      await onUpdateRakePoint(payload);
      onOpenChange(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Edit Rake Point — {rakePoint?.name}</DialogTitle>
        </DialogHeader>
        {rakePoint && (
          <EditRakePointForm
            rakePoint={rakePoint}
            onSubmit={handleSubmit}
            onCancel={() => onOpenChange(false)}
            submitting={submitting}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditRakePointDialog;
